(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalCampaignContent", modalCampaignContent);

    /** @ngInject */
    function modalCampaignContent() {
        return {
            restrict: "E",
            scope: {
                campaign: '=',
                isHub: "=",
                onExpose: "&",
                response: "=",
                onClose: "&"
            },
            controller: 'CampaignContentController',
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/campaign/campaign-content.html"
        };


    }
})();
